import { connect } from 'react-redux';
import { findPreferredGroups, updateAccount, updatePhoneVerificationDetails } from '../actions';
import Profile from './Profile';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    account = _ref.account;
  var apiRoot = _ref2.apiRoot,
    _ref2$displayPassword = _ref2.displayPassword,
    displayPassword = _ref2$displayPassword === void 0 ? false : _ref2$displayPassword,
    userIdentity = _ref2.userIdentity,
    _ref2$onUserInformati = _ref2.onUserInformationUpdated,
    onUserInformationUpdated = _ref2$onUserInformati === void 0 ? function () {} : _ref2$onUserInformati,
    formData = _ref2.formData;
  return {
    apiRoot: apiRoot,
    countries: account.countries,
    currencies: account.currencies,
    displayPassword: displayPassword,
    formData: formData,
    foundUsOptions: application.config.foundUsOptions,
    onUserInformationUpdated: onUserInformationUpdated,
    userIdentity: userIdentity
  };
};
var mapDispatchToProps = {
  findPreferredGroups: findPreferredGroups,
  updateAccount: updateAccount,
  updatePhoneVerificationDetails: updatePhoneVerificationDetails
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);